import * as Tone from "tone";
class MasterChannel {
  constructor() {
    this.master = new Tone.Gain();
    this.masterOut = new Tone.Gain().toDestination();
    this.masterOut.gain.value = 0.9
    // initializing the convolver with an impulse response

    this.convolver = new Tone.Convolver({url:"/audio/warmplate_short.wav", onload:()=>{
      console.log("loaded");
    }}).connect(this.masterOut)
    this.convolverChannel = new Tone.Channel({ volume: Tone.gainToDb(0) }).connect(
      this.convolver
    );
    this.convolverChannel.receive("convolverMaster");

    this.pingPong = new Tone.PingPongDelay("8n", 0.2).connect(this.masterOut)
    this.pingPongChannel = new Tone.Channel({ volume: Tone.gainToDb(0) }).connect(
      this.pingPong
    );
    this.pingPongChannel.receive("pingPongMaster");

    

    this.master.connect(this.masterOut);
  }

  setVolume(val, rampTime) {
    this.master.gain.rampTo(val, rampTime !== undefined ? rampTime :  0.2);
  }

  setReverb(val, rampTime) {
    this.convolverChannel.volume.cancelScheduledValues(0)
    this.convolverChannel.volume.rampTo(Tone.gainToDb(val), 0.1);
  }

  setDelay(val, rampTime) {
    this.pingPongChannel.volume.cancelScheduledValues(0)
    this.pingPongChannel.volume.rampTo(Tone.gainToDb(val), rampTime !== undefined ? rampTime : 0.1 );
  }
}
const instance = new MasterChannel();
Object.freeze(instance);

export default instance;
